import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { IonContent, IonFooter, IonHeader, IonToolbar } from "@ionic/vue";

import { ModalControllerBase } from "@/types/props";


export default /*@__PURE__*/_defineComponent({
  __name: 'ModalControllerBase',
  props: {
    noHeader: { type: Boolean },
    contentClass: {},
    footer: { type: Boolean },
    noFooterPadding: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _directive_scrollbar = _resolveDirective("scrollbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), {
      mode: "ios",
      class: _normalizeClass({'no-height': __props.noHeader})
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "header", {}, () => [
          _createVNode(_unref(IonToolbar), { class: "no-height background-purple-background" })
        ])
      ]),
      _: 3
    }, 8, ["class"]),
    _withDirectives((_openBlock(), _createBlock(_unref(IonContent), {
      class: _normalizeClass(__props.contentClass)
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"])), [
      [_directive_scrollbar]
    ]),
    (__props.footer)
      ? (_openBlock(), _createBlock(_unref(IonFooter), { key: 0 }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "footer")
          ]),
          _: 3
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})